
const msExtension = {
    msApiBase : 'api/ms/',
    apiBase : 'api/v2/'
}

const apiBaseCommunity = {
    'production': 'https://parenttown.com/',
    'staging': 'https://staging.parenttown.com/',
    'development': 'https://staging.parenttown.com/'
}

const apiBaseTap = {
    'production': 'https://api.theasianparent.com/api/v1/',
    'staging': 'https://dev-api.theasianparent.com/api/v1/',
    'development': 'https://dev-api.theasianparent.com/api/v1/'
}


export const getCommunityAPIBase = (env = 'staging', extension = 'apiBase') => {
    return `${apiBaseCommunity[['production', 'staging', 'development'].indexOf(env) !== -1 ? env : 'staging']}${msExtension[extension]}`;
}

export const getTapAPIBase = (env = 'staging') => {
    return apiBaseTap[['production', 'staging', 'development'].indexOf(env) !== -1 ? env : 'staging']
}
